import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/scale.css'; // Variables de escala proporcional
import './styles/index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
